import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import service from "../../utils/service";
const initialState = {
  assessment_answers: [],
  
};

const quizReducer = createSlice({
  name: "quizReducer",
  initialState,
  reducers: {
    setQuizAnswer(state, action) {
      state.assessment_answers = action.payload;
    },
    deleteQuizAnswer(state, action){
        if(action.payload==true){
            state.assessment_answers = []
        }
    }
   
  },
});
export const { setQuizAnswer, deleteQuizAnswer} = quizReducer.actions;
export default quizReducer.reducer;
